import React from 'react';
import MapObjectRenderer from '@components/game/objects/MapObjectRenderer';
import classnames from 'classnames';
import { CONFIG } from '@utils/constants';
import { getAssetPath } from '@utils/brandHelper';
import './TerrainTile.css';

export default function TerrainTile({
  x,
  y,
  terrain,
}) {

  const showCoordinates = CONFIG.SHOW_COORD;
  const tileClasses = classnames('map-tile', `terrain-${terrain}`);

  // Get brand-specific terrain image
  const terrainImagePath = getAssetPath(`assets/terrain/${terrain}.webp`);
  const tileStyle = {
    backgroundImage: `url(${terrainImagePath})`
  };

  return (
    <div className={tileClasses} style={tileStyle}>
      {showCoordinates && (
        <div className="tile-coordinates">
          ({x}, {y})
        </div>
      )}
    </div>
  );
}